export default __webpack_public_path__ + "static/media/text_logo.6a79bcf4.webp";